const data = ['raddad'];

export default data;
